import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=ba15f622&scoped=true&"
import script from "./Documentation.vue?vue&type=script&lang=js&"
export * from "./Documentation.vue?vue&type=script&lang=js&"
import style0 from "./Documentation.vue?vue&type=style&index=0&id=ba15f622&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba15f622",
  null
  
)

export default component.exports